import {Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {ButtonPropsModel} from "@syncfusion/ej2-popups/src/dialog/dialog-model";
import {DialogComponent} from "@syncfusion/ej2-angular-popups";
import {RequestService} from "../../../services/request/request.service";
import {FeatureFlagsService} from "../../../services/feature-flag/feature-flags.service";
import {TableGridComponent} from "../../data-grids/table-grid/table-grid.component";
import {UtilService} from "../../../services/util/util.service";
import { $translate } from 'src/app/core/services/internationalization/localize.service';

@Component({
  selector: 'sb-journal-attachment-selector',
  templateUrl: './journal-attachment-selector.component.html',
  styleUrls: ['./journal-attachment-selector.component.scss']
})
export class JournalAttachmentSelectorComponent implements OnInit {

  // Dialog support

  @ViewChild('modalDialog', {static: false})
  ejDialog: DialogComponent;

  public modalTitle: string = $translate("ng.component.journal-attachment-selector.title")`Select attachments`;

  public modalVisible = false;

  public modalPosition: any = { X: 'center', Y: 'center' };

  public modalButtons: ButtonPropsModel[] = [
    {
      'click': this.modalHideDialog.bind(this, false),
      buttonModel: {
        content: $translate("ng.component.journal-attachment-selector.button.cancel")`Cancel`,
      }
    },
    {
      'click': this.modalHideDialog.bind(this, true),
      buttonModel: {
        content: $translate("ng.component.journal-attachment-selector.button.add")`Add attachments`,
        isPrimary: true,
      }
    },
  ];

  // List support

  @ViewChild('target')
  target: ElementRef<HTMLElement>;

  @Input()
  relatedRecordId: string;

  @Input()
  relatedRecordTable: string;

  // Return a thunk that shows the modal
  @Input()
  get showDialog() {
    const self = this;
    return () => {
      self.modalShowDialog();
    };
  }

  @Input()
  editorElement: string;

  knockoutTemplateRendered: boolean = false;

  constructor(private requestService: RequestService,
              public hostElement: ElementRef,
              public featureFlagsService: FeatureFlagsService,
              public utilService: UtilService) { }

  ngOnInit(): void {
  }

  async ngAfterViewInit() {
    this.renderKnockoutTemplate();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.renderKnockoutTemplate();
  }

  public async modalHideDialog(save: boolean) {
    this.ejDialog.hide();

    if (save) {
      const tableGrid = $(".journal-attachment-selector-dialog").find("sb-ng-table-grid")[0] as unknown as TableGridComponent;
      if (tableGrid) {
        const activeEditor = ($(this.editorElement) as any)?.tinymce()?.editorManager?.activeEditor;

        const thunk = tableGrid.getSelectedRecords;
        const selectedRecords = thunk();

        selectedRecords?.forEach((r) => {
          const fileName = r.FileName.value;
          const url = `attachment/${r.id}`;
          const attachmentContent =
            `<article class="journal-attachment-wrapper journal-article-wrapper" contentEditable="false">
                <h6 class="journal-article-title">
                   <span class="journal-article-attached">Attachment:</span>
                    <a target="_blank" href="${url}">${fileName}</a>
                </h6>
            </article>`;

          if (activeEditor) {
            const content = activeEditor.getContent() || "";
            const newContent = content + "\n" + attachmentContent;

            // Done this way to ensure that the underlying field view model value is set because
            //     activeEditor.setContent(newContent);
            // will not do that.
            const data = (window as any).KO.dataFor(this.editorElement);
            const field = data.relatedRecordField
            const record = data.record;
            record[field].value(newContent);
          }
        })
      }
    }
  }

  public modalShowDialog() {
    if (this.ejDialog) {
      this.ejDialog.show();
      this.utilService.tickThen(() => {
        this.refresh();
      })
    }
  }

  private async loadApplicationProperty(key: string, def = null) {
    const response: any = await this.requestService.createRequest()
      .controller("servicely.core.Application")
      .method("getApplicationProperty")
      .data({
        key: key
      })
      .execute();
    return response && response.data ? response.data : def;
  }

  private refresh() {
    const tableGrid = $(".journal-attachment-selector-dialog").find("sb-ng-table-grid")[0] as unknown as TableGridComponent;
    if (tableGrid) {
      tableGrid.embeddedListRefresh = new Date().getTime().toString();
    }
  }

  private async renderKnockoutTemplate() {
    if (this.relatedRecordTable && this.relatedRecordId && this.target && !this.knockoutTemplateRendered) {
      const element = this.target.nativeElement;

      const genericReferenceId = `${this.relatedRecordId}:${this.relatedRecordTable}`;

      const query = {and: [
          { fieldName: "ParentRecord", operator: "=", value: genericReferenceId },
        ]};

      const parameters = {
        table: 'Attachment',
        query: JSON.stringify(query),
      };

      // TODO: the portal list method returns the correct data structure for both use cases
      // TODO: so we should pull it out as a general utility
      const response: any = await this.requestService.createRequest()
        .controller("servicely.core.Portal")
        .method("getPortalList")
        .data(parameters)
        .execute();

      const data: any = JSON.parse(response.data);

      const templateParams = {
        rendererProperties: {
          tile: "ListAutoScaffold",
          readFromParentData: {
            applyAllowReadFromParent: true,
            parentTable: this.relatedRecordTable,
            parentTableId: this.relatedRecordId,
          }
        },
        elements: [data],
      };

      (window as any).KO.cleanNode(element);
      (window as any).KO.renderTemplate("container-standard", templateParams, {}, element, "replaceNode");

      this.knockoutTemplateRendered = true;
    }
  }
}

